import api from '../api/api';
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const pedidoService = {
    IncluirPedido: async (pedidoData) => {
        try {
            const url = `${BASE_URL}/pedidos`;
            const response = await api.post(url, pedidoData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao incluir pedido:", error);
            
            // Rethrow the error to be handled by the caller
            if (error.response && error.response.data) {
                throw error.response;
            } else {
                throw new Error('Erro ao incluir pedido.');
            }
        }
    },

    // Additional methods can be added here as needed
    obterPedidoPorId: async (id) => {
        try {
            const url = `${BASE_URL}/pedidos/${id}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error(`Erro ao obter pedido ${id}:`, error);
            throw new Error(`Erro ao obter pedido ${id}.`);
        }
    },

    obterPedidosPorStatus: async (status) => {
        try {
            const url = `${BASE_URL}/pedidos/status/${status}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error(`Erro ao obter pedidos com status ${status}:`, error);
            throw new Error(`Erro ao obter pedidos com status ${status}.`);
        }
    },

    obterTodos: async (params) => {
        try {
            const url = `${BASE_URL}/pedidos/todos`;
            const response = await api.get(url, { params });
            return response.data;
        } catch (error) {
            console.error("Erro ao obter todos os pedidos:", error);
            throw new Error('Erro ao obter todos os pedidos.');
        }
    },

    obterAnexo: async (id) => {
        try {
            const url = `${BASE_URL}/pedidos/anexos/${id}`;
            const response = await api.get(url, { responseType: 'blob' });
            return response;
        } catch (error) {
            console.error("Erro ao obter anexo:", error);
            throw new Error('Erro ao obter anexo do pedido.');
        }
    }
};
